import Swiper, {
    EffectFade,
    Navigation,
    Pagination,
} from 'swiper';
import tyre from './tyre';

Swiper.use([EffectFade, Navigation, Pagination]);

const sliders = document.querySelectorAll('.js-slider');

const init = () => {
    if (sliders.length > 0) {
        sliders.forEach((slider) => {
            const opts = {
                grabCursor: true,
                navigation: {
                    nextEl: slider.querySelector('.swiper-button-next'),
                    prevEl: slider.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    clickable: true,
                    bulletActiveClass: '!opacity-100',
                    renderBullet: (index, className) => `<span class="${className} w-8 h-0.5 bg-white opacity-20 pointer-events-auto"></span>`,
                },
                slidesPerView: 'auto',
                spaceBetween: 30,
            };

            if (undefined !== slider.dataset.loop) {
                opts.loop = true;
            }

            if (undefined !== slider.dataset.fade) {
                opts.effect = 'fade';
            }

            if (undefined !== slider.dataset.centeredSlides) {
                opts.centeredSlides = true;
            }

            const swiper = new Swiper(slider, opts); // eslint-disable-line no-unused-vars
        });
    }

    tyre();
};

export default init;
